import React from 'react';
import { TokenProvider } from './api/TokenContext.js';
import { SimProvider } from './api/SimContext.js';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './components/layouts/layout/main-layout.component.jsx';
import Homescreen from './screens/homescreen/homescreen.component.jsx';
import Settingsscreen from './screens/settingsscreen/settingsscreen.component.jsx';
import Vasscreen from './screens/vasscreen/vasscreen.component.jsx';
import StoreScreenFull from './screens/storescreen-full/storescreen.component.jsx';
import ManageScreen from './screens/managescreen/managescreen.component.jsx';
import VoipScreen from './screens/voipscreen/voipscreen.component.jsx';
import SmsScreen from './screens/smsscreen/smsscreen.component.jsx'; 
import UsageScreen from './screens/sim-usagescreen/usagescreen.component.jsx';
import Aboutscreen from './screens/aboutscreen/about.component.jsx';
import Contactscreen from './screens/contactscreen/contact.component.jsx';
import { DataProvider } from './api/DataContext.js';
import AthalosscreenHome from './screens/athalosscreen/athalosscreen-home.component.jsx';
import PrsScreen from './screens/prsscreen/prsscreen.component.jsx'
import OwnScreen from './screens/ownscreen/ownscreen.component.jsx'
import AthalosScreen from './screens/athalosscreen/athalosscreen.component.jsx'
import Noconnection from './screens/noconnectionscreen/noconnection.component.jsx'
import ResellerScreenMenu from './screens/reseller/resellerscreenmenu/resellerscreenmenu.component.jsx'

function RoleBasedLayout({ role }) {
  const tokenSimProvider = (
    <TokenProvider>
      <SimProvider>
        <MainLayout />
      </SimProvider>
    </TokenProvider>
  );
  const tokenSimDataProvider = (
    <DataProvider>
        <TokenProvider>
        <SimProvider>
            <MainLayout />
        </SimProvider>
        </TokenProvider>
    </DataProvider>
  );
  switch (role) {
    case 'Reseller':
      return (
        <Routes>
          <Route element={tokenSimProvider}>
            <Route index element={<Homescreen />} />
            <Route path="home" element={<Homescreen />} />
            <Route path="settings" element={<Settingsscreen />} />
            <Route path="value-added-services" element={<Vasscreen />} />
            <Route path="store" element={<StoreScreenFull />} />
            <Route path="reseller" element={<ResellerScreenMenu />} />
          </Route>
        </Routes>
      );
      case 'TT':
        return (
          <Routes>
            <Route element={tokenSimProvider}>
              <Route index element={<Homescreen />} />
              <Route path="home" element={<Homescreen />} />
              <Route path="settings" element={<Settingsscreen />} />
              <Route path="value-added-services" element={<Vasscreen />} />
              <Route path="store" element={<StoreScreenFull />} />
              <Route path="reseller" element={<ResellerScreenMenu />} />
            </Route>
          </Routes>
        );
    case 'Admin':
      return (
        <Routes>
          <Route element={tokenSimDataProvider}>
          <Route index element={<Homescreen />} />
        <Route path="home" element={<Homescreen />} />
        <Route path="settings" element={<Settingsscreen />} />
        <Route path="portal-athalos" element={<AthalosScreen />} />
        <Route path="portal-prs" element={<PrsScreen />} />
        <Route path="portal-own" element={<OwnScreen />} />
        <Route path="value-added-services" element={<Vasscreen />} />
        <Route path="portal-home" element={<AthalosscreenHome />} />
        <Route path="overview" element={<UsageScreen />} />
        <Route path="manage" element={<ManageScreen />} />
        <Route path="store" element={<StoreScreenFull />} />
        <Route path="messages" element={<Contactscreen />} />
        <Route path="voip" element={<VoipScreen />} />
        <Route path="sms" element={<SmsScreen />} /> {/* Olav*/}
        <Route path="translator" element={<Contactscreen />} />
        <Route path="reseller" element={<ResellerScreenMenu />} />
        <Route path="about" element={<Aboutscreen />} />
        <Route path="contact" element={<Contactscreen />} />
        <Route path="no-connection" element={<Noconnection />} />
        </Route>
        </Routes>
      );
    default:
      return (
      <Routes>
        <Route element={tokenSimProvider}>
          <Route index element={<Homescreen />} />
          <Route path="home" element={<Homescreen />} />
          <Route path="settings" element={<Settingsscreen />} />

        </Route>
      </Routes>
    );
  }
}

export default RoleBasedLayout;